/**
 * NOTE: Originally wrote this for the old create rfp page
 * Copied the directive directly since the old rfp page will be removed eventually anyway
 *
 * Native elements that support the "indeterminate" attribute are (checkbox, progress and radio)
 */
export default function SetIndeterminateStateDirective() {
  return {
    restrict: 'A',
    scope: {
      indeterminate: '=aptSetIndeterminateState'
    },
    link: function ($scope: ng.IScope, element: ng.IAugmentedJQuery) {
      /**
       * @description
       * mainly wrote this for the checkbox element but there are other elements which can use this state e.g (progress, radio, etc)
       * set an element's indeterminate state
       */

      $scope.$watch('indeterminate', (val: string, oldVal) => {
        if (val != null) {
          element.prop('indeterminate', val);
        }
      });
    }
  };
}
